import * as React from 'react'

type OwnProps<V> = {
  child: React.ReactElement | null | undefined
  value: V
  onClick: (arg0: V, arg1: React.MouseEvent<any>) => unknown
}

class ValueToClickAction<V> extends React.Component<OwnProps<V>> {
  onClickAction: (arg0: React.MouseEvent<any>) => void = event => {
    this.props.onClick(this.props.value, event)
  }

  render(): React.ReactNode {
    return this.props.child != null
      ? React.cloneElement(React.Children.only(this.props.child), {
          onClick: this.onClickAction,
        })
      : null
  }
}

export default ValueToClickAction
